import React, { FC, forwardRef } from 'react';
import { Grid as GridMUI, GridProps } from '@mui/material';


export const GridContainer: FC<GridProps> = forwardRef(({ children, ...props }, ref) => (
    <GridMUI
        ref={ref}
        container
        spacing={{ mobile: '12px', tablet: '20px', desktop: '20px' }}
        {...props}
    >
        {children}
    </GridMUI>
));

export const GridItem: FC<GridProps> = forwardRef(({ children, ...props }, ref) => (
    <GridMUI item ref={ref} {...props}>
        {children}
    </GridMUI>
));
